module.exports = __webpack_public_path__ + "static/media/leader_manual.d4e7f842.pdf";